import React from "react";
import DEFAULT_FLIGHT from "../../assets/images/default-airline.png";

interface FlightImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  flightCode: string;
  size?: number;
}

export const FlightImage: React.FC<FlightImageProps> = ({
  flightCode,
  style,
  ...props
}) => {
  const src = `https://images.skyruner.com/Uploads/AirlineLogo/${flightCode}.png`;

  return (
    <img
      src={src}
      alt={flightCode}
      onError={(e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = DEFAULT_FLIGHT;
      }}
      style={{ ...style }}
      {...props}
    />
  );
};
